/**
* @ngdoc directive
* @name Numboard
*
* @description
  Shows custom number pad
*
* @scope
* @param {Number} value
* @param {Function} cancel - callback on cancel
* @param {Function} save - callback on save
*
* @example
  <div ng-init='units=1'>
    <div class='btn btn-primary' ng-click='showNumboard()'>Show Numboard</div>
    <numboard
      ng-if='numboard.isVisible'
      value='units'
      save='closeNumboard()'
      cancel='closeNumboard()'
    >
    </numboard>
  </div>
*/

app.directive('numboard', ["$window", "PATH", function ($window, PATH) {
  return {
    restrict: 'E',
    templateUrl: PATH.components + 'numboard/numboard.html',
    scope: {
      value: '=',
      cancel: '&',
      save: '&'
    },
    link: function ($scope) {
      $scope.value = $scope.value + '';
      format();

      $scope.addToValue = function(value) {
        if ($scope.value === '0' || !$scope.value) {
          if (value === '.') $scope.value = '0.';
          else $scope.value = value;
        }
        else if (value === '.' && $scope.value.indexOf('.') > -1) return;
        else $scope.value += value;

        format();
      };

      $scope.removeValue = function(value) {
        $scope.value += '';
        if ($scope.value.length === 1) {
          $scope.value = '0';
        } else if ($scope.value !== '0') {
          $scope.value = $scope.value.substring(0, $scope.value.length - 1);
        }
        format();
      };

      function format() {
        /*
          adds comma when value > 1000
          removes comma when value < 1000
        */

        $scope.value = $scope.value.replace(/\,/g,'');
        var parsedValue = parseFloat($scope.value);

        if (parsedValue >= 1000) {

          var decimalIndex = $scope.value.indexOf('.');
          if (decimalIndex > -1) {
            var valueBeforeDecimal = $scope.value.slice(0, decimalIndex);
            var valueAfterDecimal = $scope.value.slice(decimalIndex);
          } else {
            var valueBeforeDecimal = $scope.value;
            var valueAfterDecimal = '';
          }

          $scope.value = numeral(valueBeforeDecimal).format('0,00') + valueAfterDecimal;
        }
      }
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/numboard/numboardDirective.js